module.exports = __webpack_public_path__ + "img/logo-vencedoresdetarqui.8f291bf4.png";